module.exports = __webpack_public_path__ + "img/DocumentExplorer.a94c77d6.svg";